import { combineEpics } from "redux-observable";
import { upsellMessageDismissAllEpicReducer } from "../ducks/index.js";
const upsellMessageDismissAllEpic = combineEpics(upsellMessageDismissAllEpicReducer.epic);
export {
  upsellMessageDismissAllEpic
};
//# sourceMappingURL=upsellMessageDismissAll.epic.js.map
